import { render, staticRenderFns } from "./PromotionRowCTAMBRExp.vue?vue&type=template&id=e10376ce&scoped=true"
import script from "./PromotionRowCTAMBRExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotionRowCTAMBRExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotionRowCTAMBRExp.vue?vue&type=style&index=0&id=e10376ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10376ce",
  null
  
)

export default component.exports